module.exports = __webpack_public_path__ + "fonts/frame_136_2.svg";